import React, { useContext } from 'react';

export interface User {
  email: string;
  name: string;
  firstName: string;
  lastName: string;
  phone: string;
  id?: number;
}

export interface MobileUser {
    firstName: string;
    lastName: string;
    email: string;
  }

interface UserContextType {
    user: User | undefined;
    setUser: (user: User) => void;
    mobileUser: MobileUser | undefined;
    setMobileUser: (mobileUser: MobileUser) => void;
}

export const UserContext = React.createContext<UserContextType | undefined>(
    undefined
);

export const useUserContext = () => {
    const userContext = useContext(UserContext);

    if (!userContext) {
        throw new Error('No UserContext.Provider found when calling useUserContext');
    }

    return userContext;
}
